// Example JavaScript equivalent (no interfaces)
import moment from 'moment';

export const guarantorUpdateData = {
    paymentMethod: "",
    eftUpdate: "",
    paymentDate: "",
    eftSuspended: "",
    guarantorType: null, // no typing
    subscriberId: "",
    guarantorId: "",
    noChecks: false,
    noCreditCards: false,
    creditClass: "",
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    firstName: "",
    lastName: "",
    email: "",
    autoPayMethod: "",
    phoneNumber: "",
  
    // Optional fields can simply be omitted if not needed
    jobTitle: "",
    monthsEmployed: "",
    selfEmployed: "",
    employerContactName: "",
    employerPhoneNumber: "",
    employerEmailAddress: "",
    employerAddressName: "",
    employerAddressLine1: "",
    employerAddressLine2: "",
    employerAddressCity: "",
    employerStateProvId: "",
    employerPostalCode: "",
    employerCountryId: "",
  
    residenceOwnOrRent: "",
    residenceMonths: "",
    landlordName: "",
    landlordContactName: "",
    landlordPhoneNumber: "",
    landlordEmailAddress: "",
  
    eftAccountType: "",
    eftAuthNameStart: "",
    eftAuthNameEnd: "",
    eftAccountFirstName: "",
    eftAccountLastName: "",
    eftAccountMiddleInit: "",
    eftAccountOrgName: "",
    eftBankPhoneNumber: "",
    eftCreditCardBrand: "",
    eftCreditCardNumber: "",
    eftCreditCardExpiration: "",
    eftExternalAccountToken: "",
    eftBankAuthMethod: "",
    eftBankAccountType: "",
    eftBankRoutingNumber: "",
    eftBankAccountNumber: ""
  };
  
  export const guarantorProcessPaymentData = {
    subscriberId: "",
    guarantorId: "",
    profileId: "",
    paymentAmount: "",
    paymentCode: "",
    paymentMethod: "",
    payToken: "",
    paymentDate: "",
    balanceGroup: "",
    creditCardType: "",
    creditCardNumberLast4: "",
    creditCardExpirationMonth: "",
    creditCardExpirationYear: "",
    bankRoute: "",
    bankAccountLast4: "",
    bankAccountType: "",
    bankAccountClass: "",
    emailAddress: ""
  };

  export const generateCardExpiryDateTime = (expiryDate) => {
    const inputFormat = 'MM/YYYY'; // Input format for expiry date
    const momentObj = moment(expiryDate, inputFormat);
  
    if (!momentObj.isValid()) {
      return 'Invalid date'; // Return this if the date string doesn't match the format or is invalid
    }
  
    const lastDayOfMonth = momentObj.endOf('month').format('YYYY-MM-DD-HH.mm.ss');
  
    return lastDayOfMonth;
  };

  export const paymentus_encrypted_url = async (requestData,acessToken) => {
    try {
      const api =`${process.env.REACT_APP_PAYMENT_BASE_URL}/payment/paymentus/encrypt`;

      const response = await fetch(api, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: acessToken,
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        console.error('Failed to fetch encrypted URL');
        return null;
      }
      const result = await response.json();
      return result?.url || null;
    } catch (error) {
      console.error('Encryption API error:', error);
      return null;
    }
  };

  
